import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { I18nextProvider } from "react-i18next";
import i18n from "./components/i18next/i18n";


// import config
import { socket } from './config/socketConnectivity';

// import Context
import SocketContext from './context/SocketContext';

// helper route
import HelperRoute from './components/Route/HelperRoute';
import routes from './routes';

// import redux
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';

// import api
import { decodeJwt } from './api/jsonWebToken';

// import lib
import isLogin from './lib/isLogin';
import { getAuthToken, getLang, setLang } from './lib/localStorage';
import isEmpty from "./lib/isEmpty";

const AppRoutes = () => {
  return useRoutes(routes);
};

const App = () => {

  const { isAuth } = store.getState().auth;

  // console.log(isAuth,'isAuthisAuth')

  useEffect(() => {
    if (isAuth != true && isLogin()) {
      decodeJwt(getAuthToken(), store.dispatch)
    }
    let lang = getLang();
    if (isEmpty(lang)) {
      i18n.changeLanguage("en")
      setLang("en")
    } else {
      i18n.changeLanguage(lang)
    }

  }, [])

  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        {/* <PersistGate loading={null} persistor={persistor}> */}
        <BrowserRouter basename="/">
          <SocketContext.Provider value={{ socket }}>
            <HelperRoute />
            <ToastContainer />
            <AppRoutes />
          </SocketContext.Provider>
        </BrowserRouter>
        {/* </PersistGate> */}
      </I18nextProvider>
    </Provider>
  );
};

export default App;